import { CorrectValueSource, DiscrepancyResolutionTarget } from "generated-graphql/graphql";

import type {
  CorrectValueSourceLiteral,
  ResolutionTargetLiteral,
} from "./resolveWithValue.helpers";

/** The resolveDiscrepancies enum for each client-side source literal. */
export const CORRECT_VALUE_SOURCE: Record<CorrectValueSourceLiteral, CorrectValueSource> = {
  EMANIFEST: CorrectValueSource.Emanifest,
  VENDOR: CorrectValueSource.Vendor,
  DOCUMENT: CorrectValueSource.Document,
  MANUAL: CorrectValueSource.Manual,
};

/** The resolveDiscrepancies enum for each client-side target literal. */
export const RESOLUTION_TARGET: Record<ResolutionTargetLiteral, DiscrepancyResolutionTarget> = {
  VENDOR_DATA: DiscrepancyResolutionTarget.VendorData,
  EMANIFEST: DiscrepancyResolutionTarget.Emanifest,
  DOCUMENT: DiscrepancyResolutionTarget.Document,
};
